import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import React, {
    useRef,
    useState,
    useCallback,
    useLayoutEffect,
    useEffect,
    useContext,
} from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import {
    useViewportScroll,
    useTransform,
    useSpring,
    motion,
} from 'framer-motion'

import { FormattedMessage } from 'react-intl'

import Button, { StyledButton } from './Button'
import Container from './Container'
import LayoutContext from './LayoutContext'
import LanguageDropdown from './LanguageDropdown'
import { Variables } from '../styles/Variables'
import { physics } from './SmoothScroll'

const StickyHeader = styled(motion.div)`
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 998;

    ${media('<desktop')} {
        z-index: 1;
    }

    ${(props) =>
        props.isZoomOpen &&
        css`
            z-index: 0;
        `}
    
    ${StyledButton} {
        font-family: ${Variables.font.bodyBold};
        ${media('>desktop')} {
            font-size: 14px;
        }
        ${media('<desktop')} {
            width: 181px;
            font-size: 12px;
        }
    }
`

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding-top: 22px;
    padding-bottom: 40px;

    ${media('<desktop')} {
        transition: 0.3s background-color ease-out;
    }

    ${(props) =>
        props.invert &&
        css`
            ${media('<desktop')} {
                background-color: ${Variables.color.cocoa};
            }
        `}
`

const Header = () => {
    const { SidebarOpen, setSidebarOpen } = useContext(LayoutContext)


    const [shouldShowActions, setShouldShowActions] = useState(false)
    const [lastYPos, setLastYPos] = useState(0)

    useEffect(() => {
        function handleScroll() {
            const yPos = window.scrollY
            const isScrollingUp = yPos < lastYPos

            setShouldShowActions(isScrollingUp)
            setLastYPos(yPos)
        }
        window.addEventListener('scroll', handleScroll, false)

        return () => {
            window.removeEventListener('scroll', handleScroll, false)
        }
    }, [lastYPos])

    // scroll container
    const scrollRef = useRef(null)

    // page scrollable height based on content length
    const [pageHeight, setPageHeight] = useState(0)

    // update scrollable height when browser is resizing
    const resizePageHeight = useCallback((entries) => {
        for (let entry of entries) {
            setPageHeight(entry.contentRect.height)
        }
    }, [])

    // observe when browser is resizing
    useLayoutEffect(() => {
        const resizeObserver = new ResizeObserver((entries) =>
            resizePageHeight(entries)
        )
        scrollRef && resizeObserver.observe(scrollRef.current)
        return () => resizeObserver.disconnect()
    }, [scrollRef, resizePageHeight])

    const { scrollY } = useViewportScroll()
    const stickyHeaderHeight = shouldShowActions ? 0 : -pageHeight
    const transform = useTransform(
        scrollY,
        [0, pageHeight],
        [0, stickyHeaderHeight]
    )

    const spring = useSpring(transform, physics)

    return (
        <>
            <StickyHeader ref={scrollRef} style={{ y: spring }}>
                <HeaderWrapper invert={SidebarOpen}>
                    <Container>
                        <LanguageDropdown/>
                        <AnchorLink href='#contactForm'>
                            <Button>
                                <FormattedMessage
                                    id="reserve"
                                />
                            </Button>
                        </AnchorLink>
                    </Container>
                </HeaderWrapper>
                {/* <Logo>
                    <Link to={path}>
                        <LogoInverted
                            src={LogoInvertSvg}
                            alt=""
                            open={SidebarOpen}
                        />
                        <LogoImg src={LogoSvg} alt="Pazola" open={SidebarOpen} />
                    </Link>
                </Logo> */}
            </StickyHeader>
        </>
    )
}

export default Header
